module.exports = __webpack_public_path__ + "static/img/2.00bece0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/eng/2.png
// module id = 8EzD
// module chunks = 0